import { render, staticRenderFns } from "./StocklistComponent.vue?vue&type=template&id=0f0cfc06&"
import script from "./StocklistComponent.vue?vue&type=script&lang=js&"
export * from "./StocklistComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports